var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]}},[_c('button',{staticClass:"buttonWrap",attrs:{"aria-label":_vm.$t('burger-button.aria-label')},on:{"click":_vm.openMobileNavigation}},[(!_vm.isNewHeader)?_c('span',{staticClass:"body"}):_c('Icon',_vm._b({},'Icon',_vm.iconConfig,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }